export default __webpack_public_path__ + "static/media/skipPauseIcon.85e422b3.png";